<app-busy-indicator [isBusy]="isBusy" size="big"></app-busy-indicator>
<div class="content-header bg-primary block" [class.bg-image]="hasBgImage" [ngClass]="class" [class.hide-breadcrumb]="hideBreadcrumb">
	<app-breadcrumb *ngIf="!hideBreadcrumb" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
	<div *ngIf="activeMenu" @fadeIn>
		<mat-icon *ngIf="activeMenu.icon && !picture" class="mat-icon-xlg">{{activeMenu.icon}}</mat-icon>
		<h1>{{activeMenu.header}}</h1>
		<h4 class="p-2">{{activeMenu.desc}}</h4>
	</div>
</div>